import React, { Fragment, useState } from "react";
import { Card, Typography } from "@mui/material";
import { EditHeader } from "../editProfilePage/EditHeader";
import useStore from "../../../states/store";
import { GenericDialog } from "../../../components/generic/GenericDialog";
import { EditContactForm } from "../editProfilePage/EditContactForm";

const EditContactPage = () => {
  const [{ loggedIndUserDetails }] = useStore();
  const [openEditContactDialog, setOpenEditContactDialog] = useState(false);

  return (
    <Fragment>
      <Typography variant="h5" fontWeight={700} color="primary.main">Edit Contact</Typography>
      <Typography mb={2}>Review and update your preferred contact details and collab requirements. In the &apos;Requirements&apos; section, refine or expand on your content collab specifics, including topics of interest and any deadlines.</Typography>
      <Card>
        <EditHeader label={'Collab Contact Method'} action={() => setOpenEditContactDialog(true)} />
        <Typography variant="subtitle1" margin={'15px 0'}>{loggedIndUserDetails?.contact_details}</Typography>
        <Typography className="subTitle" mb={'15px'}>Instruction/Requirement Details</Typography>
        <Typography variant="subtitle1">{loggedIndUserDetails?.instructions}</Typography>
      </Card>
      <GenericDialog
        title={'Edit Contact'}
        width={'854px'}
        openDialog={openEditContactDialog}
        handleClose={() => setOpenEditContactDialog(false)}
      >
        <EditContactForm
          creatorDetails={loggedIndUserDetails}
          handleClose={() => setOpenEditContactDialog(false)}
        />
      </GenericDialog>
    </Fragment>
  );
};

export default EditContactPage;